import { type PlatformDataResponse, type Release } from "api/dashboardBackend";
import styles from "components/dashboard/release-card/ReleaseStatus.module.scss";
import PerAppStoreReleaseStatus from "components/dashboard/release-card/per-app-store-release-status/PerAppStoreReleaseStatus";
import { PlatformId } from "util/platform";
import { buildVersionString } from "util/version";

interface Props {
  release: Release;
  platformData: PlatformDataResponse;
}

const ReleaseStatus = ({ release, platformData }: Props) => {
  if (platformData.platform.id.toLowerCase() === PlatformId.China) {
    return (
      <PerAppStoreReleaseStatus
        platformId={platformData.platform.id}
        versionString={buildVersionString(release)}
      />
    );
  }

  return <div className={styles.title}>{release.status}</div>;
};

export default ReleaseStatus;
